import {z} from 'zod';

export const MAX_MESSAGE_LENGTH = 1000;

export const messageValidator = z.string().trim().max(MAX_MESSAGE_LENGTH, `message;max;${MAX_MESSAGE_LENGTH}`);
